import React from 'react';
import './Dot.css';

const Dot = ({ title, desc, date, id, variant = 'main' }) => {
    return (
        <div className='dot-container'>
            <div className='sketch'>
                <span className={`dot dot--${variant}`} id={id}></span>
                <span className={`line line--${variant}`}></span>
            </div>
            <div>
                <h3>{title}</h3>
                <p><i>{desc}</i></p>
            </div>
        </div>
    );
};

export default Dot;